import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import firebaseConfig from "./config";

const messagingApp = initializeApp(firebaseConfig, "messaging");
const messaging = getMessaging(messagingApp);

export const solicitarToken = async () => {
  try {
    if (!("serviceWorker" in navigator)) {
      console.log("❌ El navegador no soporta Service Workers");
      return null;
    }

    const registration = await navigator.serviceWorker.register(
      "/firebase-messaging-sw.js"
    );

    console.log("✅ Service Worker registrado:", registration.scope);

    const permiso = await Notification.requestPermission();

    if (permiso !== "granted") {
      console.log("❌ Permiso de notificaciones no concedido");
      return null;
    }

    const token = await getToken(messaging, {
      vapidKey: "BNT6syrROePjf-qGmpvgn-82lES-gkWV__Xw6BQzw4Mc7xl19ULQndlKWHzQOYtFPhohwnYuaw4t0uQHgqMo5yA",
      serviceWorkerRegistration: registration,
    });

    if (token) {
      console.log("✅ Token FCM obtenido");
      return token;
    }

    console.log("⚠️ No se obtuvo token FCM");
    return null;
  } catch (error) {
    console.error("❌ Error obteniendo token FCM:", error);
    return null;
  }
};
export const escucharMensajes = (callback) => {
  return onMessage(messaging, (payload) => {
    console.log("🔔 Mensaje FCM recibido:", payload);

    if (callback) {
      callback(payload);
    }
  });
};